export default "__VITE_ASSET__Bz$xkBOd__"